import settingsUrlMappings from '../../constants/SettingsURLMappings';
import getCurrentApp from '../getCurrentApp';
import { getPortalId } from '../getPortalId';
import getWindow from '../getWindow';
import strToRegExp from '../strToRegExp';
const isKnownSettingsRoute = pathname => {
  const portalId = getPortalId();
  if (!portalId) return false;
  return Object.values(settingsUrlMappings).some(({
    to
  }) => {
    const toLink = `${to.replace('**{portalId}**', `${portalId}`)}`;
    const toLinkRegExp = strToRegExp(toLink);
    if (!toLinkRegExp) return false;
    return toLinkRegExp.test(pathname);
  });
};
const getIsSettingsPage = () => {
  const {
    pathname
  } = getWindow().location;
  const currentApp = getCurrentApp(pathname);
  return /(-?settings)|(-preferences)/i.test(currentApp) || isKnownSettingsRoute(pathname) || document.querySelector('[data-reagan-test="settings-page"]') !== null;
};
export default getIsSettingsPage;